import { SET_DATA_KEY } from '../../constants'

export function isSetRestSetDataUtil (set) {
  return set[SET_DATA_KEY.REST] != null
}
